import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal as BootstrapModal } from 'react-bootstrap';
import SearchSelect from '@spark/ui-components/components/form/SearchSelect';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import { colorBackground, colorFieldsBorder, colorText } from '@spark/ui-components/theme/palette';
import { depotStatusOptions } from '../../config/statusOptions';

const UpdateDepotStatusModal = ({
  show,
  onClose,
  onConfirm,
  onStatusChange,
  selectedStatus,
  containerNumber,
  loading = false,
}) => (
  <StyledModal show={show} onHide={loading ? undefined : onClose} centered>
    <div className="modal-content">
      <Title>Alterar status do container</Title>
      <Description>
        Selecione o novo status da programação
        {containerNumber ? ` para o container ${containerNumber}` : ''}.
      </Description>

      <FieldWrapper>
        <SearchSelect
          label="Status"
          placeholder="Selecione o status"
          options={depotStatusOptions}
          value={selectedStatus}
          onChange={onStatusChange}
          disabled={loading}
        />
      </FieldWrapper>

      <ButtonGroup>
        <Button variant="secondary" onClick={onClose} disabled={loading ? 'true' : undefined}>
          Cancelar
        </Button>
        <ButtonWithLoading
          variant="primary"
          onClick={onConfirm}
          loading={loading ? 'true' : undefined}
          loadingText="Salvando..."
          disabled={!selectedStatus?.value}
        >
          Salvar
        </ButtonWithLoading>
      </ButtonGroup>
    </div>
  </StyledModal>
);

UpdateDepotStatusModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  selectedStatus: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  containerNumber: PropTypes.string,
  loading: PropTypes.bool,
};

export default UpdateDepotStatusModal;

const StyledModal = styled(BootstrapModal)`
  .modal-dialog {
    max-width: 520px;
  }

  .modal-content {
    background-color: ${colorBackground};
    border: 1px solid ${colorFieldsBorder};
    padding: 24px;
    color: ${colorText};
    border-radius: 4px;
  }
`;

const Title = styled.h4`
  font-weight: 700;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  margin-bottom: 20px;
`;

const FieldWrapper = styled.div`
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
